import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AutoHeightSheetOptions, autoHeightSheetOptions } from 'src/app/utils/auto-height-sheet';

export interface OptionPickerItem {
  label: string;
  value: string;
}

/** Ids únicos para nombrar el radiogroup con su título. */
let nextTitleId = 0;

/** Clase propia del ion-modal del selector (radio superior y ancho en tablet). */
const OPTION_PICKER_MODAL_CLASS = 'option-picker-modal';

export interface OptionPickerSheetOptions extends Omit<AutoHeightSheetOptions, 'cssClass'> {
  readonly cssClass: string[];
  readonly handle: boolean;
}

/** Opciones de apertura del selector: sheet ajustado al contenido, con handle. */
export function optionPickerSheetOptions(): OptionPickerSheetOptions {
  const sheet = autoHeightSheetOptions();
  return {
    ...sheet,
    cssClass: [sheet.cssClass, OPTION_PICKER_MODAL_CLASS],
    handle: true,
  };
}

@Component({
  selector: 'app-option-picker-modal',
  templateUrl: './option-picker-modal.component.html',
  styleUrls: ['./option-picker-modal.component.scss'],
  standalone: false
})
export class OptionPickerModalComponent {

  @Input() title = '';
  @Input() options: OptionPickerItem[] = [];
  @Input() selectedValue = '';

  readonly titleId = `option-picker-title-${nextTitleId++}`;

  constructor(private modalCtrl: ModalController) {}

  selectOption(value: string): void {
    this.modalCtrl.dismiss({ selectedValue: value });
  }
}
